import React, { useEffect, useState, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";


const OriginalTicketDetailsReport = ({ openOriginalTicketDetailsReport, dateFrom, dateTo, selectedRegionIds, changeRegionIds, reportUrl }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [allreportsNew, setAllReportsNew] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const timeoutRef = useRef(null);


    const [dataTable, setDataTable] = useState({
        page: 0,
        size: 10,
        search: '',
        order: null,
    });

    const setTable = (tableState) => {
        setDataTable({
            page: tableState.page,
            search: tableState.searchText,
            size: tableState.rowsPerPage,
            order: tableState.sortOrder
        });
    };

    const columns = [
        {
            label: "Date",
            name: 'issuedDate',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px', display: 'inline-block' }}>{value}</p>
                )
            }
        },
        {
            label: "Category",
            name: 'category',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Branch',
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Ticket No",
            name: 'ticketNumber',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Counter",
            name: 'counterName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Teller",
            name: 'tellerName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Issued Time",
            name: 'issuedTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Call Time",
            name: 'startTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Wait Time",
            name: 'waitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Service Time",
            name: 'serviceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Total Customer Time",
            name: 'totalCustomerTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Close Time",
            name: 'closeTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Mobile No",
            name: 'mobileNumber',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Status",
            name: 'status',
            options: {
                sort: true,
                filter: false,
            }
        },

    ];

    const options = {
        // tableBodyHeight: '55vh',
        filterType: 'dropdown',
        filter: false,
        responsive: 'vertical',
        serverSide: true,
        count: count,
        download: false,
        jumpToPage: true,
        selectableRows: 'none',
        storageKey: '_qr_otd_table',
        print: false,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        onTableChange: (action, tableState) => {

            // a developer could react to change on an action basis or
            // examine the state as a whole and do whatever they want

            switch (action) {
                case 'changePage':
                    getOriginalTicketDetailsReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'sort':
                    getOriginalTicketDetailsReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    getOriginalTicketDetailsReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'search':
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(() => getOriginalTicketDetailsReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage), 2000);
                    setTable(tableState);
                    break;
                default:
                    break;
            }
        },
    };



    // call getOriginalTicketDetailsReport - useEffect
    useEffect(() => {
        if (openOriginalTicketDetailsReport) {
            if (dateFrom.length > 0 && dateTo.length > 0) {
                getOriginalTicketDetailsReport(0, null, null, rowsPerPage);
            }
        }
    }, [openOriginalTicketDetailsReport, dateFrom, dateTo])

    // when change selected region array, call getOriginalTicketDetailsReport - useEffect
    useEffect(() => {
        if (openOriginalTicketDetailsReport) {
            getOriginalTicketDetailsReport(0, null, null, rowsPerPage);
        }
    }, [changeRegionIds])



    // getOriginalTicketDetailsReport - function
    const getOriginalTicketDetailsReport = (page, sortOrder, search, size) => {
        setIsLoading(true);

        axios({
            method: 'POST',
            url: `${reportUrl}/report-controller/get-all-original/ticket-data/branch/paginated/customer/${userDetails.cid}`,
            headers: {
                Authorization: token
            },
            data: {
                "page": page,
                "size": size,
                "dateFrom": dateFrom,
                "dateTo": dateTo,
                "sort": sortOrder,
                "searchText": search,
                branchIds: selectedRegionIds
            }

        }).then((res) => {

            let data = res.data.data;
            setAllReportsNew((data.content))
            setCount(data.totalElements);

            setIsLoading(false)

        }).catch((error) => {
            console.log(error);
            setIsLoading(false)

            if (error.response !== undefined) {
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }

    return (
        <>
            <div><ToastContainer /></div>

            <MUIDataTable
                title={
                    <>
                        {isLoading ?
                            <CircularProgress color="secondary" size={20} /> : <>{count} records.</>}
                    </>
                }
                data={allreportsNew}
                columns={columns}
                options={options}
                className='text-center-table'
            />

        </>
    )
}

export default OriginalTicketDetailsReport
